import React from 'react';
import {
  Stack, Skeleton,
} from '@mui/material';
import DetailsCard from './DetailsCard';

const UserProfileSkeleton = () => (
  <Stack
    direction="column"
    spacing={3}
  >
    <DetailsCard
      items={[
        {
          title: <Skeleton width={50} />,
          content: <Skeleton width={125} />,
        },
        {
          title: <Skeleton width={50} />,
          content: <Skeleton width={125} />,
        },
        {
          title: <Skeleton width={50} />,
          content: <Skeleton width={125} />,
        },
        {
          title: <Skeleton width={50} />,
          content: <Skeleton width={125} />,
        },
        {
          title: <Skeleton width={50} />,
          content: <Skeleton width={125} />,
        },
      ]}
    />
  </Stack>
);

export default UserProfileSkeleton;
